import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { not } from 'ramda';
import ServiceFetcher from '../../shared/libs/ServiceFetcher';
import { TryCatchGeneric, checkServerError } from '../../shared/utils';
import * as appLoaderActions from '../store/slices/appLoader'
import * as appApisActions from '../store/slices/appApis'
import { ROUTES } from '../router';

const useGetParameters = () =>  {

  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [statusService, setStatusService] = useState({ data: undefined, error: undefined });

  const fetchParameters = async () => {
    setIsLoading(true);
    await TryCatchGeneric(
      () => ServiceFetcher('/parameter'),
      setStatusService,
      setIsLoading,
      () => { }
    );
  };

  const { data, error } = statusService;

  useEffect(() => {
    if (not(data)) return;
    dispatch(appApisActions.setParameters(data));
  }, [data]);

  useEffect(() => {
    dispatch(isLoading ? appLoaderActions.showAppLoader() : appLoaderActions.hideAppLoader());
  }, [isLoading]);

  useEffect(() => {
    if (not(error)) return;
    if (checkServerError(error)) history.push(ROUTES.ERROR)
  }, [error])

  return {
    data,
    fetchParameters,
  };
}

export default useGetParameters;